import { useQuery } from "@tanstack/react-query"

import { OrganizationsResponses } from "@tfg/types/endpoints/organizations"

import { httpClient } from "~/backend/axios.ts"

export const useListOrganizationContactsQuery = () => {
  return useQuery({
    queryKey: ["organizationId", "contacts"],

    queryFn: async () => {
      const response = await httpClient.get<OrganizationsResponses.Contact[]>(
        `organizations/contacts`
      )
      return response.data
    },
  })
}
